module.exports = __webpack_public_path__ + "img/elecciones20217.9f857784.jpg";